module.exports = __webpack_public_path__ + "bb8c380122597bdf917aa6962805778e.pdf";